import Api from "../apiService";

class driversApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/drivers`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, driverId) {
    return Api.getRequest(
      `companies/${companyId}/drivers/${driverId}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, driverData) {
    return Api.postRequest(
      `companies/${companyId}/drivers`,
      driverData,
      Api.authHeaders()
    );
  }

  update(companyId, driverId, driverData) {
    return Api.patchRequest(
      `companies/${companyId}/drivers/${driverId}`,
      driverData,
      Api.authHeaders()
    );
  }

  enable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/drivers/${id}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/drivers/${id}/disable`,
      {},
      Api.authHeaders()
    );
  }
}

export default new driversApi();
